import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/page';
import AboutUs from './pages/About-Us'
import ContactUs from './pages/contact-us';
import Service from './pages/service';
import Apply from './pages/apply-now';
import Condition from './pages/Term-and-Condition';
import Disclaimer from './pages/disclaimer';
import FAQ from './pages/FAQ';
import Privacypolicy from './pages/Privacy-policy';
import Repay from './pages/Repay';
import Refundpolicy from './pages/refundpolicy';
import KycPolicy from './pages/KycPolicy';
import GrievancePolicy from './pages/GrievancePolicy';
import InterestRatePolicy from './pages/InterestRatePolicy';
import ThankYou from './pages/Thankyou';
import WallStreetLoader from './components/WallStreetLoader';

function App() {
  return (
    <div className="App">
       {/* Preloader - Optional, usually better to handle via state or remove if pure React */}
      {/* <div className="preloader">
        <div className="loading-container">
          <div className="loading-text">
            <span>W</span><span>A</span><span>L</span><span>L</span>
            <span>S</span><span>T</span><span>R</span><span>E</span><span>E</span><span>T</span>
          </div>
        </div>
      </div> */}
      
      <WallStreetLoader />

    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/service" element={<Service />} />
        {/* <Route path="/apply-now" element={<Apply />} /> */}
        <Route path="/Term-and-condition" element={<Condition />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/repay" element={<Repay />} />
        <Route path="/refundpolicy" element={<Refundpolicy />} />
        <Route path="/KycPolicy" element={<KycPolicy />} />
        <Route path="/GrievancePolicy" element={<GrievancePolicy />} />
        <Route path="/InterestRatePolicy" element={<InterestRatePolicy />} />
        <Route path="/Thankyou" element={<ThankYou />} />
      </Routes>
      <Footer />
    </Router>
      {/* Scroll to top */}
      <a className="scroll-to-target scroll-to-top" data-target="html" href="/#">
        <span className="scroll-to-top-img">
          <img
            src="/assets/images/logo.png"
            alt="Go Top"
            style={{ width: "100px", height: "65px" }}
          />
        </span>

        <span className="scroll-to-top-wrapper">
          <span className="scroll-to-top-inner"></span>
        </span>
      </a>
    </div>

  );
}

export default App;